/** Normalize a string for guess matching: lowercase, strip diacritics, normalize quotes */
function normalize(str: string): string {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")  // strip diacritics (é→e, ñ→n)
    .replace(/[''`]/g, "'")           // normalize quotes
    .replace(/[""]/g, '"')            // normalize double quotes
    .trim();
}

/** Strip version/edition suffixes like "(feat. Artist)", "(Remix)", "[Radio Mix]" */
function stripParens(str: string): string {
  return str.replace(/\s*[\[(].*?[\])]/g, "").trim();
}

function titleMatches(correct: string, guessed: string): boolean {
  const c = normalize(correct);
  const g = normalize(guessed);
  const cBase = normalize(stripParens(correct));
  const gBase = normalize(stripParens(guessed));
  return c.includes(g) || g.includes(c) || cBase.includes(gBase) || gBase.includes(cBase);
}

function artistMatches(correct: string, guessed: string): boolean {
  const c = normalize(correct);
  const g = normalize(guessed);
  return c.includes(g) || g.includes(c);
}

/**
 * Check if a guess matches the correct song. Accepts bilingual storage:
 * if title_he/artist_he are provided, a match against either the canonical
 * (EN) or Hebrew form counts as correct.
 */
export function isGuessCorrect(
  correctTitle: string,
  correctArtist: string,
  guessedTitle: string,
  guessedArtist: string,
  correctTitleHe?: string | null,
  correctArtistHe?: string | null
): { titleMatch: boolean; artistMatch: boolean } {
  const titleMatch =
    titleMatches(correctTitle, guessedTitle) ||
    (!!correctTitleHe && titleMatches(correctTitleHe, guessedTitle));
  const artistMatch =
    artistMatches(correctArtist, guessedArtist) ||
    (!!correctArtistHe && artistMatches(correctArtistHe, guessedArtist));

  return { titleMatch, artistMatch };
}
